var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dms-input',{attrs:{"value":_vm.LeasCisSchval,"disabled":_vm.isDisabled || _vm.isZakazkaDisabled || !_vm.LeaszakaznikId,"label-key":"LEAS_CIS_SCHVAL"},on:{"update:value":function($event){_vm.LeasCisSchval=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }